var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"chart"}},[_c('apexchart',{attrs:{"type":"treemap","height":_vm.height,"width":_vm.width,"options":_vm.treemap.chartOptions,"series":_vm.treemap.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }